// extracted by mini-css-extract-plugin
module.exports = {"adminPractice":"AdminResult_adminPractice__b2f_Q","hover":"AdminResult_hover__1pxNO"};